import Type from "@/model/types/Type";



const type = {
    STATUS_COMMON : 1,
    STATUS_FINISH_SUCCESS : 2,
    STATUS_FINISH_ERROR : 3,

}

const list = [
    {
        value: type.STATUS_COMMON,
        text: "Comum",
    },
    {
        value: type.STATUS_FINISH_SUCCESS,
        text: "Finalização com sucesso",
    },
    {
        value: type.STATUS_FINISH_ERROR,
        text: "Finalização com erro (reprovado)",
    },
]


const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}


